<header class="mathia-activity-search-dialog__header">

    <h2 class="mathia-activity-search-dialog__title">
        {{ 'activity_search.panel_title' | translate }}
    </h2>

    <app-activity-selection-actions [selectedCount]="selectedActivityCount"
                                    (clearSelection)="clearSelection()"
                                    (validateSelection)="close()">
    </app-activity-selection-actions>

    <button class="mathia-activity-search-dialog__close-button"
            matDialogClose>
        <mat-icon svgIcon="cross"></mat-icon>
    </button>

</header>

<div class="mathia-activity-search-dialog__content">

    <app-mathia-lessons-search-filter (selectionChange)="onSelectionChange($event)">
    </app-mathia-lessons-search-filter>

    <app-activities-search-viewer [activitySearchOptions]="activitySearchOptions">
        <ng-template let-activity="activity">
            <app-pretty-activity-card [class.active]="isSelected(activity.id)"
                                      [activity]="activity">
                <ng-container data-actions>
                    <button [class.pretty-card__select-button]="!isSelected(activity.id)"
                            [class.pretty-card__cancel-button]="isSelected(activity.id)"
                            (click)="toggleActivity(activity.id)">
                        @if (!isSelected(activity.id)) {
                            <mat-icon svgIcon="check"></mat-icon>
                        }
                        <span>{{ (isSelected(activity.id) ? 'generic.cancel' : 'generic.select') | translate }}</span>
                    </button>
                </ng-container>
            </app-pretty-activity-card>
        </ng-template>
    </app-activities-search-viewer>

</div>
